import { checkScriptIsLoaded, documentHead, ResolutionStrategy, loadScript } from '../script-loader.esm.js';

var checkApiIsLoaded = function () { return window.mapboxgl; };
var checkApiIsLoading = function () { return window.mapboxglLoading; };
var urls = function (version, languagePluginVersion) { return ({
    jsUrl: "https://api.mapbox.com/mapbox-gl-js/v".concat(version, "/mapbox-gl.js"),
    cssUrl: "https://api.mapbox.com/mapbox-gl-js/v".concat(version, "/mapbox-gl.css"),
    pluginUrls: [
        "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-language/v".concat(languagePluginVersion, "/mapbox-gl-language.js")
    ]
}); };
/**
 * Identify each versions to used and use default values if not found.
 *
 * @param sdk versions
 */
var identifyMapboxSdkVersions = function (version) {
    var mapboxVersion = '2.9.2';
    var languagePluginVersion = '1.0.0';
    if (version) {
        version.split(';').forEach(function (part) {
            var _a = part.split(':'), key = _a[0], value = _a[1];
            if (value === undefined) {
                value = key;
                key = 'version';
            }
            switch (key) {
                case 'version':
                    mapboxVersion = value;
                    break;
                case 'mapbox-gl-language':
                    languagePluginVersion = value;
                    break;
            }
        });
    }
    return {
        mapboxVersion: mapboxVersion,
        languagePluginVersion: languagePluginVersion
    };
};
/**
 * Load mapbox api.
 *
 * @param reloadSDK force to reload sdk if already loaded. Useful when you want to change the locale that has been loaded.
 * @param conf the api configuration to used
 * @param resolveImmediately don't way for mapbox callback to revolve this call.
 * @returns returns true if the api was loaded through this call, and false if the api was already loaded and not force to be reloaded.
 */
var initMapBoxApi = function (reloadSDK, conf, resolveImmediately) {
    return new Promise(function (resolve) {
        var scriptId = 'load-mapbox';
        if (checkApiIsLoaded() && !reloadSDK) {
            resolve(false);
        }
        else if (checkApiIsLoading()) {
            checkScriptIsLoaded('mapboxgl', checkApiIsLoaded, checkApiIsLoading, { delay: 200, maxRetries: 100 }).then(function () {
                return resolve(false);
            });
        }
        else {
            window.mapboxglLoading = true;
            window.mapboxgl = undefined;
            var _a = identifyMapboxSdkVersions(conf.version), mapboxVersion = _a.mapboxVersion, languagePluginVersion = _a.languagePluginVersion;
            var _b = urls(mapboxVersion, languagePluginVersion), jsUrl = _b.jsUrl, cssUrl_1 = _b.cssUrl, pluginUrls = _b.pluginUrls;
            var head_1 = documentHead();
            // Scripts
            var promises_1 = [];
            var resolution_1 = resolveImmediately ? ResolutionStrategy.IMMEDIATELY : ResolutionStrategy.ON_LOAD_EVENT;
            var timeoutDuration_1 = 10000;
            if (jsUrl) {
                promises_1.push(loadScript(jsUrl, true, scriptId, resolution_1, timeoutDuration_1));
            }
            pluginUrls.forEach(function (pluginUrl, index) {
                promises_1.push(loadScript(pluginUrl, true, "".concat(scriptId, "-plugins-").concat(index), resolution_1, timeoutDuration_1));
            });
            if (cssUrl_1) {
                promises_1.push(new Promise(function (styleSheetResolve) {
                    var styleId = "".concat(scriptId, "-style");
                    var prev = document.getElementById(styleId);
                    if (prev) {
                        prev.remove();
                    }
                    var link = document.createElement('link');
                    link.setAttribute('id', styleId);
                    link.rel = 'stylesheet';
                    link.href = cssUrl_1;
                    head_1.appendChild(link);
                    styleSheetResolve();
                }));
            }
            Promise.all(promises_1).then(function () {
                window.mapboxglLoading = undefined;
                resolve(true);
            });
        }
    });
};

export { initMapBoxApi };
